// Work history, extracted from the resume. An entry may carry flat `bullets`
// or, when a single role spans multiple tracks, a `tracks` array.
export const experiences = [
  {
    company: "Amdocs",
    role: "Software Development Engineer",
    period: "Aug 2024 – Present",
    location: "Gurugram, India",
    current: true,
    tracks: [
      {
        name: "InnOVerse (Agentic Crowd) — GenAI Team",
        period: "Mar 2026 – Present",
        stack: ["React", "Node.js", "Express.js", "PostgreSQL", "Docker", "RBAC / ABAC"],
        bullets: [
          "Re-architected an internal GenAI asset platform (MCP servers, rules, AI tools, skills) into a multi-tenant SaaS product for 4 telecom clients via a shared-core + per-client-delivery Feature-Sliced architecture.",
          "Designed a centralized RBAC / Policy Decision Point (ABAC-lite) — 20 permissions, 10 roles, 3 enforcement modes — and led a zero-downtime migration off a legacy role enum across backend, JWT and frontend.",
          "Built a FastAPI semantic / vector-search (RAG) microservice (7 endpoints, top-K ranking) with 15s timeouts and graceful fallback, powering retrieval, similarity and duplicate detection.",
          "Built a broker-free, PostgreSQL-backed notification system (33 typed notifications, 8 domains, 2 channels) with O(1) broadcast fan-out, removing a message-broker dependency.",
          "Implemented enterprise auth (Azure AD SSO / MSAL, NTLM, LDAP) with a Redis-backed session store; shipped via GitLab CI/CD as separate Podman images behind an nginx TLS edge.",
        ],
      },
      {
        name: "Real-Time Billing & SKY Fallout Management (AT&T, USA)",
        period: "Aug 2024 – Mar 2026",
        stack: ["Java", "Spring Boot", "React", "Kafka", "Couchbase", "Jenkins"],
        bullets: [
          "Enhanced the fallout-handling stack (Java, Spring Boot, Jenkins, JESI, Kafka, PostgreSQL, React) into a reliable, scalable solution integrating multiple workspaces, migrating 1,000,000+ customers seamlessly.",
          "Implemented caching across three Spring Boot microservices using Couchbase (15-min TTL) to speed up API lookups.",
          "Enhanced the billing simulator to support amend/cancel orders via dedicated Kafka consumers and producers.",
          "Built a new fallout-management workspace for the SKY customer migration, auto-updating dashboards on Kafka events with custom auto/manual ticket resolution.",
          "Built EnvStatus, an MS Teams bot for environment status and pod versions (OpenShift); ran 20+ feature certifications in Postman across 4 teams.",
        ],
      },
    ],
  },
  {
    company: "QuickReel",
    role: "Software Developer Intern",
    period: "Feb 2023 – Apr 2023",
    location: "Remote",
    stack: ["React", "Redux", "Node.js", "MongoDB", "AWS S3", "Stripe", "Docker"],
    bullets: [
      "Developed a full-stack AI-based automatic video-editing web app generating social-media-ready short clips, integrating Stripe to get, renew and cancel monthly & annual subscriptions.",
      "Built REST APIs spanning video upload, processing and retrieval, storing media in AWS S3 and metadata in MongoDB, with a React + Redux client and a Docker-containerized backend.",
      "Optimized backend processing from 30 min to 45 s, and built a web-based video player with custom playback controls and OAuth login.",
    ],
  },
];

export default experiences;
